export default __webpack_public_path__ + "dd7a43cd7a9dca0f36699d86c9077b96.png";